import React, { useContext } from "react";
import "./contact-info.component.scoped.scss";
import { useTranslation } from "react-i18next";
import { icons } from "../../statics/icons";
import { GlobalContext } from "../../store";
import { CardComponent } from "../card/card.component";

export default function ContactInfo(props: any) {
  const { t } = useTranslation();

  const { user, contactData } = useContext(GlobalContext);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <div className="contact-card">
            <CardComponent
              icon={icons.user}
              title={t("YOUR_pAIper_ADMIN")}
              active={false}
              minHeight="145px"
            >
              <div className="card-content">
                <div className="row">
                  <div className="card-main-text col-4 mt-3 mb-4">
                    {user.type === "user" ||
                    (user.role !== "coordinator" && user.type === "superUser")
                      ? contactData.primary_contact_name
                      : contactData.primary_contact_name}
                  </div>
                  <div className="col-6 mt-3 d-flex flex-column">
                    <div className="card-sec-text mb-1">
                      {user.type === "user" ||
                      (user.role !== "coordinator" && user.type === "superUser")
                        ? contactData.primary_contact_email
                        : contactData.primary_contact_email}
                    </div>
                    <div className="card-sec-text">
                      {user.type === "user" ||
                      (user.role !== "coordinator" && user.type === "superUser")
                        ? contactData.primary_contact_phone
                        : contactData.primary_contact_phone}
                    </div>
                  </div>
                </div>
              </div>
            </CardComponent>
          </div>
        </div>
        <div className="col-6">
          <div className="contact-card">
            <CardComponent
              icon={icons.support}
              title={"pAIper Support"}
              active={false}
              minHeight="145px"
            >
              <div className="card-content">
                <div className="row">
                  <div className="card-text col-5 mt-3 d-flex flex-column">
                    <div className="card-main-text mb-2">
                      {t("technical questions?")}
                    </div>
                    <div className="card-main-text">
                      {t("organisational questions?")}
                    </div>
                  </div>
                  <div className="col-6 mt-3 d-flex flex-column">
                    <div className="card-sec-text mb-2">
                      {contactData.technical_contact_email}
                    </div>
                    <div className="card-sec-text">
                      {contactData.organization_contact_email}
                    </div>
                  </div>
                </div>
              </div>
            </CardComponent>
          </div>
        </div>
      </div>
    </>
  );
}
